import { Site } from '@envato/foundation-types'
import * as React from 'react'

import AudioJungleItemCard from './audioJungleItemCard'
import GraphicRiverItemCard from './graphicRiverItemCard'
import NarrowItemCard from './narrowItemCard'
import PhotoduneGridItemCard from './photoduneGridItemCard/photoduneItemCardContainer'
import VideoHiveItemCard from './videoHiveItemCard/videoHiveItemCardContainer'

import { IProps } from './itemCardContainer'

const ItemCard = ({ currentSite, ...props }: IProps): any => {
  if (currentSite === Site.photodune) {
    return <PhotoduneGridItemCard {...props} />
  } else if (currentSite === Site.graphicriver) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.threedocean) {
    return <GraphicRiverItemCard {...props} />
  } else if (currentSite === Site.audiojungle) {
    return <AudioJungleItemCard {...props} />
  } else if (currentSite === Site.videohive) {
    return <VideoHiveItemCard {...props} />
  } else {
    return <NarrowItemCard {...props} />
  }
}

export default ItemCard
